import React, { useState, useEffect } from 'react';
import { Fab, Zoom } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Zoom in={isVisible}>
      <Fab
        color="primary"
        size="large"
        aria-label="scroll back to top"
        onClick={scrollToTop}
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          zIndex: 1000,
          backgroundColor: '#e3662d',
          color: 'white',
          boxShadow: '0 4px 20px rgba(227, 102, 45, 0.3)',
          '&:hover': {
            backgroundColor: '#d55a1f',
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 32px rgba(227, 102, 45, 0.4)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <KeyboardArrowUp sx={{ fontSize: 28 }} />
      </Fab>
    </Zoom>
  );
};

export default BackToTop;
